import { Skeleton } from "../../ui"

export const PdpLoader = () => (
    <div className="flex flex-col space-y-2.75">
        <Skeleton className="h-6 w-15" />
        <Skeleton className="h-6 w-[280px]" />
        <Skeleton className="h-6 w-15" />
        <Skeleton className="h-6 w-[140px]" />
        <Skeleton className="h-6 w-[200px]" />
    </div>
)
